import {Tooltip} from 'platform/components';
import {Box, HStack, Icon, Show, Text, TextAlign, ThemeColorPath} from 'platform/foundation';

const HEADER_BACKGROUND_COLOR: ThemeColorPath = 'palettes.neutral.10.100';
const HEADER_PADDING_VERTICAL = 2;
const HEADER_PADDING_HORIZONTAL = 3;
const TOOLTIP_ICON_SIZE = 3;

interface SalesLeagueTableHeaderCellProps {
  label: string;
  align: TextAlign;
  tooltip?: string;
}

export function SalesLeagueTableHeaderCell(props: SalesLeagueTableHeaderCellProps) {
  return (
    <Box
      backgroundColor={HEADER_BACKGROUND_COLOR}
      paddingVertical={HEADER_PADDING_VERTICAL}
      paddingHorizontal={HEADER_PADDING_HORIZONTAL}
    >
      <HStack
        spacing={1}
        align="center"
        justify={props.align === 'right' ? 'flex-end' : 'flex-start'}
      >
        <Text size="xSmall" align={props.align} noWrap alternative>
          {props.label.toUpperCase()}
        </Text>
        <Show when={props.tooltip}>
          <Tooltip description={props.tooltip}>
            <Icon value="action/info_outline" size={TOOLTIP_ICON_SIZE} color="text.secondary" />
          </Tooltip>
        </Show>
      </HStack>
    </Box>
  );
}
